export default {
  methods: {
	redirectUrl: function (url) {
		switch(url){
			case 'providers':
				return 0
			case 'info':
				return 1
			case 'report':
				return 2
			case 'programs':
				return 3
			case 'roles-permissions':
				return 4
			case 'disciplines':
				return 5
			case 'locations':
				return 6
			case 'automation':
				return 7
			case 'import':
				return 8
			case 'integration':
				return 9
		}	
    },

  }
};



// WEBPACK FOOTER //
// ./src/components/shared/AgencyViewMixin.js